import View from "../common/views/CartCountView";
import components from "./components.js";
components.define("js-CartCount", View);